import { DashboardRouter } from "../dashboard.router";

export class UsersRouter {
    
    static getRoute(): string {
        return `${DashboardRouter.getRoute()}/users`
    }

}